import type { TOC } from '@ember/component/template-only'
import type { AwardsEarnedReRoute } from 'teacher-ui-client/reporting/ui-scope/re/awards-earned/route'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import ReportingTeacherUiHeader from 'teacher-ui-client/components/reporting/teacher-ui-header'
import fullGradeName from 'teacher-ui-client/helpers/full-grade-name'
import ReportingDetailedControls from 'teacher-ui-client/components/reporting/detailed-controls'
import ReportingNoDataMessageIf from 'teacher-ui-client/components/reporting/no-data-message-if'
import { not } from 'ember-truth-helpers'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import Tooltip from 'teacher-ui-client/components/tooltip'
import isSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { AwardsEarnedCertificatesHistory } from 'teacher-ui-client/components/giraffe/charts/awards-earned/certificates/history'
import { AwardsEarnedCertificatesTotals } from 'teacher-ui-client/components/giraffe/charts/awards-earned/certificates/totals'
import { camelize } from '@ember/string'
import { t } from 'ember-intl'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<AwardsEarnedReRoute>
}

export const ReAwardsEarned: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.awardsEarned.re"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{if @model.awardsEarnedTotals true false}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.awardsEarnedTotals}}>
    {{#each @model.awardsEarnedTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 relative my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <AwardsEarnedCertificatesTotals
          @data={{gradeData}}
          @product={{@model.product}}
          @title={{t "reporting.chartTitles.awardsEarnedTotals.re"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.awardsEarnedTotals." (camelize @model.uiScope.scope))}}
          @grade={{fullGradeName gradeData.grade_position}}
          @yAxisTitle={{t "reporting.chartTitles.awardsEarnedTotals.re"}}
        />
        <span class="absolute top-0 right-1 print:hidden">
          <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-4 w-4 cursor-pointer" />
          <Tooltip @text={{t "reporting.tooltips.awardsEarnedTotals.re" htmlSafe=true}} />
        </span>
      </div>
    {{/each}}

    {{#if @model.awardsEarnedHistory}}
      <AwardsEarnedCertificatesHistory
        @certificatesHistoryData={{@model.awardsEarnedHistory}}
        @students={{@model.scopedStudents}}
        @subco={{(isSubco)}}
        @product={{@model.product}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.re.student-summary"
        @tooltip={{t "reporting.tooltips.awardsEarnedHistory.re" htmlSafe=true}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReAwardsEarned)
